import MedicalWaste from '../components/MedicalWaste';

function MedicalWastePage() {
  return <MedicalWaste />;
}

export default MedicalWastePage;
